<template>
  <div class="mx-0 mx-md-3 mx-lg-5">
    <div class="row">
      <div class="col">
        <div
          v-if="cartsWithItems.length > 1 || (cartsWithItems.length == 1 && activeCart.dynamicIndex != cartsWithItems[0].dynamicIndex)"
          class="rounded p-2"
          style="background-color: #eaebf0"
        >
          <BushelBtn
            v-for="cart in cartsWithItems"
            :key="cart.dynamicIndex"
            class="mx-1 py-2"
            :variant="activeCart.dynamicIndex == cart.dynamicIndex ? 'light-primary' : 'secondary'"
            btn-content-class="d-flex"
            :flat="activeCart.dynamicIndex != cart.dynamicIndex"
            @click="fetchFullCart(cart)"
          >
            <span class="mb-auto mt-auto align-bottom">
              {{ cart.name }}
            </span>

            <span
              class="ml-2 d-inline-block circle-cart-items border px-2"
              :class="activeCart.dynamicIndex == cart.dynamicIndex ? 'border-white text-primary bg-white' : 'border-primary text-primary'"
            >
              {{ cart.cart_items_count }} Item<span v-if="cart.cart_items_count > 1">s</span>
            </span>
          </BushelBtn>
        </div>
        <BushelCard v-if="loadingCart" class="mt-3" body-class="p-0 overflow-auto" style="max-height: 800px; background: transparent !important">
          <Loading />
        </BushelCard>
        <BushelCard v-if="createdOrder" class="mt-3" body-class="p-0 overflow-auto" style="max-height: 800px; background: transparent !important">
          <div class="mb-3 mt-3 ml-3">
            <BushelBtn variant="primary" :ripple="false" @click="$emit('backToStorefrontAndFetchItems')">
              <i class="fas fa-arrow-left" />
              Place another order
            </BushelBtn>
          </div>

          <div class="p-4 text-center">
            <div v-if="isTheSeller">
              <img class="img-fluid" style="max-height: 250px" src="/img/onboard/1-price-enterprise.png" />
              <h5 class="text-success">Success! The order has been created.</h5>
              <BushelBtn variant="primary" @click="$emit('viewOrders')"> Go to Your Orders </BushelBtn>
            </div>
            <div v-else-if="loggedIn">
              <img class="img-fluid" style="max-height: 250px" src="/img/onboard/1-price-enterprise.png" />
              <h5 class="text-success">Success! A confirmation has been sent to your email</h5>
              <BushelBtn variant="primary" @click="$emit('viewOrders')"> Go to Your Orders </BushelBtn>
            </div>
            <div v-else class="mt-4">
              <div
                v-if="buyerData && buyerData.buyer_company && buyerData.buyer_company.id"
                class="rounded text-center ml-auto mr-auto mt-4 p-3 d-print-none"
                style="background-color: #fbfbfb"
              >
                <h5 class="text-primary mb-3">Thanks for placing your order! A confirmation has been sent to your email.</h5>
                <div class="row">
                  <div class="col-12 col-lg-6 mt-2 mt-lg-3">
                    <p class="mb-2 text-larger">
                      We noticed that you have an account but checked out as a guest. Would you like to login to view this order and access other
                      platform features?
                    </p>
                    <div class="">
                      <div class="mt-2 mt-md-0">
                        <BushelBtn variant="success" style="width: 40%" @click="$emit('viewOrders')"> Sign In </BushelBtn>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 d-none d-lg-block">
                    <img style="max-height: 165px" src="/img/onboard/1-price-enterprise.png" />
                  </div>
                </div>
              </div>
              <div v-else class="rounded text-center ml-auto mr-auto mt-4 p-3 d-print-none" style="background-color: #fbfbfb">
                <h4 class="text-primary mb-5 mt-3">Thanks for placing your order! A confirmation has been sent to your email.</h4>

                <h5 class="text-primary mb-3">Elevate your buying experience today by creating a free account on {{ appName }}</h5>
                <div class="row">
                  <div class="col-12 col-lg-6 d-none d-lg-block">
                    <img style="max-height: 165px" src="/img/onboard/1-price-enterprise.png" />
                  </div>
                  <div class="col-12 col-lg-6 mt-2 mt-lg-3">
                    <ul class="ml-auto mr-auto list-unstyled list-inline-item" style="text-align: left">
                      <li>
                        <img src="img/icons/checked.svg" height="20" />
                        <p class="d-inline">Explore all the brands available on the Marketplace</p>
                      </li>
                      <li>
                        <img src="img/icons/checked.svg" height="20" />
                        <p class="d-inline">Easily make payments online with PayNow</p>
                      </li>
                      <li>
                        <img src="img/icons/checked.svg" height="20" />
                        <p class="d-inline">Live chat with the brand sales team</p>
                      </li>
                      <li>
                        <img src="img/icons/checked.svg" height="20" />
                        <p class="d-inline">Track order statuses real-time</p>
                      </li>
                      <li>
                        <img src="img/icons/checked.svg" height="20" />
                        <p class="d-inline">Place orders for multiple locations at once</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <BushelBtn variant="callout" class="m-2 mt-3 min-270px" @click="$emit('startSneakyRegister', { noReloadAfterAuth: true })">
                  Create Free Account
                </BushelBtn>
              </div>
            </div>
            <div v-if="cartsWithItems.length > 1 || (cartsWithItems.length == 1 && activeCart.dynamicIndex != cartsWithItems[0].dynamicIndex)">
              <h4 class="text-black-50 mt-5 mb-2 text-center">Don't Forget Your Other Carts!</h4>
              <BushelBtn
                v-for="cart in cartsWithItems"
                :key="cart.dynamicIndex"
                class="mx-1 py-2"
                btn-content-class="d-flex"
                outline
                @click="fetchFullCart(cart)"
              >
                <span class="mb-auto mt-auto align-bottom">
                  {{ cart.name }}
                </span>
              </BushelBtn>
            </div>
          </div>
        </BushelCard>
        <BushelCard
          v-else-if="!loadingCart && cartItems.length < 1"
          class="mt-3"
          body-class="p-0"
          style="max-height: 800px; background: transparent !important"
        >
          <div class="text-center p-5">
            <img class="img-fluid" src="/img/misc/empty-cart-4.gif" alt="Your Cart Is Empty" />
            <h2 class="text-black-50 mt-3 mb-2 text-center">This Cart Is Empty</h2>
            <BushelBtn variant="success" outline class="ml-auto mr-auto" style="max-width: 600px" :ripple="false" @click="$emit('backToStorefront')">
              Add Items
            </BushelBtn>
            <div v-if="cartsWithItems.length > 1 || (cartsWithItems.length == 1 && activeCart.dynamicIndex != cartsWithItems[0].dynamicIndex)">
              <h4 class="text-black-50 mt-3 mb-2 text-center">Or Choose Another Cart</h4>
              <BushelBtn
                v-for="cart in cartsWithItems"
                :key="cart.dynamicIndex"
                class="mx-1 py-2"
                btn-content-class="d-flex"
                outline
                @click="fetchFullCart(cart)"
              >
                <span class="mb-auto mt-auto align-bottom">
                  {{ cart.name }}
                </span>
              </BushelBtn>
            </div>
          </div>
        </BushelCard>

        <div v-else-if="!loadingCart && cartItems.length > 0">
          <div v-if="activeCart.suggested_cart && !isTheSeller" class="alert alert-info mt-4 text-center">
            This cart was created by {{ storefrontCompany.name }} for your review. Please note these products are still available for purchase by
            others and may sell out quickly.
          </div>

          <CartOrderBreakout
            v-for="(group, index) in internalGroups"
            :key="group.identifier"
            :buyer="buyerData"
            :dispatching-order="dispatchingOrder"
            :is-the-seller="isTheSeller"
            :group-count="Object.keys(internalGroups).length"
            :seller-operation="group.masterOperation"
            :group-number="Number(index)"
            :order-details="orderDetails"
            :us-cannabis-user="usCannabisUser"
            :cart-items="group.items"
            :group="group"
            :storefront-company="storefrontCompany"
            :seller-company-name="storefrontCompany.name"
            :cart-minimums="cartMinimums"
            :submitted="submitted"
            :is-suggested-cart="activeCart ? activeCart.suggested_cart : false"
            @remove-from-cart="(val) => $emit('removeFromCart', val)"
            @adjust-to-max-quantity-in-cart="(val) => $emit('adjustToMaxQuantityInCart', val)"
            @handle-update-quantity="(val) => $emit('handleUpdateQuantity', val)"
            @update-field-in-group="updateFieldInGroup"
          />
          <BushelCard v-if="!isObjEmpty(cartMinimums) || inventoryStockIssue" class="mt-4">
            <div v-if="inventoryStockIssue">
              <div class="alert alert-warning mb-0">Product stock has changed recently. Please adjust your cart items.</div>
            </div>
            <div v-else-if="!isObjEmpty(cartMinimums)" class="alert alert-warning mb-0">
              <div v-for="min in cartMinimums" :key="min.operationName">
                Minimum Order Values not met for the location:
                {{ min.operationName }}
                <div v-if="min.type == 'total'">
                  Required minimum order of
                  {{ currency(min.minimum) }}
                </div>
                <div v-else>
                  Minimums Not Met
                  <div v-for="m in min.failedCategories" :key="m.id">
                    {{ m.category.name }}:
                    {{ currency(m.price) }}
                  </div>
                </div>
              </div>
            </div>
          </BushelCard>
          <BushelCard v-else-if="loggedIn && isTheSeller" class="mt-4">
            <div v-if="activeCart.suggested_cart" class="row">
              <div class="col-12 col-lg-6 mt-auto mb-auto">
                <div class="mt-1">
                  <div class="mb-3 text-center">
                    <h4 v-if="buyerData">You are currently viewing an order proposal for {{ buyerData.name }} and have 3 options.</h4>
                  </div>
                  <ol>
                    <li>Message {{ buyerData.name }} directly through your account so they can review and place the order.</li>
                    <li>
                      Copy the order proposal link and send it through your personal email or preferred method to {{ buyerData.name }} for their
                      review.
                    </li>
                    <li>
                      Return to the storefront and select {{ buyerData.name }}'s location prior to adding products and checkout on their behalf.
                    </li>
                  </ol>
                </div>
              </div>
              <div class="col-12 col-lg-6 text-center mt-auto mb-auto">
                <div style="background: rgb(234, 235, 240)" class="mx-2 rounded p-4 mt-3 mt-lg-0">
                  <h5 class="mb-3">Let {{ buyerData.name }} Know</h5>
                  <BushelBtn flat outline class="btn-block" @click="showingBuyerContactModal = true"> Message Buyer </BushelBtn>
                  <BushelBtn flat class="btn-block" outline @click="copyStorefrontLink">
                    Copy Proposal Link
                    <span v-if="linkCopied" class="ml-2">
                      Copied
                      <i class="fa fa-check" />
                    </span>
                  </BushelBtn>
                  <BuyerContactModal
                    :user="user"
                    default-success-message="Proposal Sent"
                    show-menu-link
                    :from-company="storefrontCompany"
                    default-salutation="Hello"
                    default-subject="Order Proposal"
                    is-proposal-link
                    default-menu-button-text="View Proposal"
                    default-menu-helper-text="Click View Proposal below to review and place the order. If you would like to add additional products you may do so by clicking Back to Storefront in the upper left corner of the order screen."
                    default-message="Below is a link to an order proposal that I put together for you. Please note that other buyers can order these products and the available quantity may change so act quickly."
                    :buyer-id="buyerData.id"
                    :buyer-uuid="buyerData.uuid"
                    :buyer-linked="buyerData.buyer_company_id ? true : false"
                    :show="showingBuyerContactModal"
                    @hide="showingBuyerContactModal = false"
                  />
                </div>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-12 text-center mt-auto mb-auto">
                <div style="background: rgb(234, 235, 240)" class="mx-2 rounded p-4 mt-3 mt-lg-0">
                  <div class="ml-auto mr-auto mt-4">
                    <h4 v-if="buyerData.net_terms_id" class="d-inline text-primary">
                      {{ "Terms" }}:
                      {{ buyerData.term.name }}
                    </h4>

                    <h4 class="text-primary">
                      <b>Final Total: {{ currency(finalTotal) }}</b>
                    </h4>
                  </div>
                  <BushelBtn
                    v-if="user && user.id && userCan('create orders for buyer', user)"
                    class="ml-auto mr-auto mt-3 min-180px"
                    :loading="dispatchingOrder"
                    variant="success"
                    :disabled="!storefrontCompany.approved || dispatchingOrder || (buyerData && buyerData.hold)"
                    @click="createOrder"
                  >
                    <span v-if="!dispatchingOrder">Place Order</span>
                  </BushelBtn>
                  <div v-else class="alert alert-info">Sorry, you don't have permissions to create orders. Please talk to your administrator</div>
                  <div v-if="buyerData && buyerData.hold" class="alert alert-warning mt-3">This buyer is on hold.</div>
                </div>
              </div>
            </div>
          </BushelCard>
          <BushelCard v-else class="mt-4">
            <div class="row">
              <div v-if="!activeCart.buyer_operation_id" class="col-12 col-lg-6">
                <div v-if="showLocationSelect || showOperationSelect" class="row bg-auth-6 mx-0 my-2 p-2 rounded">
                  <div v-if="showLocationSelect && showOperationSelect" class="col-12 col-md-6 mt-auto mb-auto text-center">
                    <div class="d-inline-block">
                      <div class="radio form-check-inline">
                        <input id="addressTypeRadio1" v-model="addressType" value="Operation" type="radio" />
                        <label for="addressTypeRadio1" class="text-white"> My Locations</label>
                      </div>
                      <div class="radio form-check-inline">
                        <input id="addressTypeRadio2" v-model="addressType" value="Location" type="radio" />
                        <label for="addressTypeRadio2" class="text-white"> Provided Locations </label>
                      </div>
                    </div>
                  </div>
                  <div v-if="showOperationSelect && (addressType == 'Operation' || !showLocationSelect)" class="col-12 col-md-6">
                    <BushelSelect
                      :searchable="false"
                      :allow-empty="true"
                      :custom-label="customBuyerLabel"
                      track-by="id"
                      label="name"
                      label-class="text-white text-header-300"
                      :options="selectableOperations"
                      :label-active="'Select Location'"
                      thin
                      :value="selectedBuyerOperation"
                      @select="operationSelected"
                      @remove="clearBuyerOperationLocationData"
                    />
                  </div>
                  <div v-if="showLocationSelect && (addressType == 'Location' || !showOperationSelect)" class="col-12 col-md-6">
                    <BushelSelect
                      :searchable="false"
                      :allow-empty="true"
                      :custom-label="customBuyerLabel"
                      track-by="id"
                      label="name"
                      label-class="text-white text-header-300"
                      :options="selectableLocations"
                      :label-active="'Select Location'"
                      thin
                      :value="selectedBuyerLocation"
                      @select="locationSelected"
                      @remove="clearBuyerOperationLocationData"
                    />
                  </div>
                </div>
                <div class="row">
                  <div v-if="!buyerData.buyer_company || !buyerData.buyer_company.id" class="col-12">
                    <div class="row">
                      <div v-if="selectableContacts && selectableContacts.length" class="col-12 col-md-6">
                        <BushelSelect
                          :custom-label="customContactLabel"
                          track-by="id"
                          label="name"
                          :options="selectableContacts"
                          label-active="Autofill From Seller Provided Contacts"
                          thin
                          :value="selectedOrderEmail"
                          @select="buyerContactSelected"
                        />
                      </div>
                      <div class="col-12 col-md-6">
                        <BushelTextInput
                          v-model="orderDetails.buyer_manually_entered_email"
                          :error="
                            submitted &&
                            (!buyerData.buyer_company || !buyerData.buyer_company.id) &&
                            !validateEmail(orderDetails.buyer_manually_entered_email)
                          "
                          label-active="Email"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <BushelTextInput
                      v-model="orderDetails.ship_name"
                      type="text"
                      thin
                      :error="submitted && !orderDetails.ship_name"
                      :label-active="'Ship To'"
                    />
                  </div>
                  <div v-if="usCannabisUser" class="col-12 col-lg-6">
                    <BushelTextInput
                      v-model="orderDetails.buyer_state_license"
                      type="text"
                      thin
                      :error="submitted && !orderDetails.buyer_state_license"
                      :label-active="'State License Number'"
                    />
                  </div>
                </div>
                <!-- </div>
                <div class="col-12 col-lg-6"> -->
                <div class="row">
                  <div class="col-12 col-md-6">
                    <BushelTextInput
                      v-model="orderDetails.ship_line_one"
                      thin
                      type="text"
                      :error="submitted && !orderDetails.ship_line_one"
                      :label-active="'Address Line One'"
                    />
                  </div>
                  <div class="col-12 col-md-6">
                    <BushelTextInput v-model="orderDetails.ship_line_two" thin type="text" :label-active="'Address Line Two'" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <BushelTextInput
                      v-model="orderDetails.ship_city"
                      type="text"
                      thin
                      :error="submitted && !orderDetails.ship_city"
                      :label-active="'City'"
                    />
                  </div>
                  <div class="col-12 col-md-6">
                    <BushelTextInput
                      v-model="orderDetails.ship_state"
                      thin
                      type="text"
                      :error="submitted && !orderDetails.ship_state"
                      :disabled="usCannabisUser"
                      :label-active="'State'"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <BushelTextInput
                      v-model="orderDetails.ship_zip"
                      thin
                      type="text"
                      :error="submitted && !orderDetails.ship_zip"
                      :label-active="'Postal Code'"
                    />
                  </div>
                  <div class="col-12 col-md-6">
                    <BushelTextInput
                      v-model="orderDetails.ship_country"
                      thin
                      type="text"
                      :disabled="usCannabisUser"
                      :error="submitted && !orderDetails.ship_country"
                      :label-active="'Country'"
                    />
                  </div>
                </div>
              </div>

              <div
                v-if="!loggedIn && (!buyerData || !buyerData.buyer_company || !buyerData.buyer_company.id)"
                class="col-12 text-center mt-auto mb-auto"
                :class="activeCart.buyer_operation_id ? '' : 'col-lg-6'"
              >
                <div style="background: rgb(234, 235, 240)" class="d-flex flex-wrap justify-content-around align-items-center mx-2 rounded p-3">
                  <div v-if="buyerData.net_terms_id || storefrontCompany.terms_and_conditions || storefrontCompany.backorder_tos">
                    <h4 v-if="buyerData.net_terms_id" class="d-inline text-primary">
                      {{ "Terms" }}:
                      {{ buyerData.term.name }}
                    </h4>
                    <div v-if="storefrontCompany.terms_and_conditions || storefrontCompany.backorder_tos">
                      <BushelBtn flat class="btn-sm" @click="showingTerms = !showingTerms"> View Terms & Conditions </BushelBtn>
                      <TermsAndConditionsModal
                        :show="showingTerms"
                        :terms="storefrontCompany.terms_and_conditions"
                        :pre-order-terms="storefrontCompany.backorder_tos"
                        @hide="showingTerms = false"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="ml-auto mr-auto">
                      <h4 class="text-primary">
                        <b>Final Total: {{ currency(finalTotal) }}</b>
                      </h4>
                      <div>
                        <BushelBtn
                          v-if="!user || !user.id || userCan('make orders', user)"
                          class="ml-auto mr-auto mt-1 min-180px align-top"
                          :loading="dispatchingOrder"
                          variant="success"
                          :disabled="!storefrontCompany.approved"
                          @click="createOrder"
                        >
                          <span v-if="!dispatchingOrder"> Place Order As Guest </span>
                        </BushelBtn>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pb-2 mb-2 border-top mt-5">
                  <div>
                    <h4 class="mt-5 text-primary">Don't Miss Out, Create Your Free Account Today!</h4>
                    <BushelBtn variant="callout" class="min-180px mt-3" @click="$emit('startSneakyRegister', { noReloadAfterAuth: true })">
                      Create Free Account
                    </BushelBtn>
                  </div>
                </div>
              </div>

              <div v-else-if="!loggedIn" class="col-12 text-center mt-auto mb-auto" :class="activeCart.buyer_operation_id ? '' : 'col-lg-6'">
                <img src="img/misc/store-graphs.png" class="img-fluid" style="height: 208px" />
                <div style="background: rgb(234, 235, 240)" class="d-flex flex-wrap justify-content-around align-items-center mx-2 rounded p-3">
                  <div v-if="buyerData.net_terms_id || storefrontCompany.terms_and_conditions || storefrontCompany.backorder_tos">
                    <h4 v-if="buyerData.net_terms_id" class="d-inline text-primary">
                      {{ "Terms" }}:
                      {{ buyerData.term.name }}
                    </h4>
                    <div v-if="storefrontCompany.terms_and_conditions || storefrontCompany.backorder_tos">
                      <BushelBtn flat class="btn-sm" @click="showingTerms = !showingTerms"> View Terms & Conditions </BushelBtn>
                      <TermsAndConditionsModal
                        :show="showingTerms"
                        :terms="storefrontCompany.terms_and_conditions"
                        :pre-order-terms="storefrontCompany.backorder_tos"
                        @hide="showingTerms = false"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="border-bottom pb-2 mb-2">
                      <!-- v-if="buyerData &&
                        buyerData.buyer_company &&
                        buyerData.buyer_company.id
                    "
                  > -->
                      <div>
                        <BushelBtn variant="success" outline class="mb-3 min-180px" @click="$emit('startSneakyLogin')"> Sign In </BushelBtn>
                      </div>
                      <!-- <div v-else>
                        <BushelBtn
                          variant="callout"
                          outline
                          class="mb-3 min-180px"
                          @click="$emit('startSneakyRegister',{noReloadAfterAuth: true})"
                        >
                          Create Free Account
                        </BushelBtn>
                      </div> -->
                    </div>

                    <div class="ml-auto mr-auto">
                      <h4 class="text-primary">
                        <b>Final Total: {{ currency(finalTotal) }}</b>
                      </h4>
                      <div>
                        <BushelBtn
                          v-if="!user || !user.id || userCan('make orders', user)"
                          class="ml-auto mr-auto mt-1 min-180px align-top"
                          :loading="dispatchingOrder"
                          variant="success"
                          :disabled="!storefrontCompany.approved"
                          @click="createOrder"
                        >
                          <span v-if="!dispatchingOrder"> Place Order As Guest </span>
                        </BushelBtn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="col-12 text-center mt-auto mb-auto" :class="activeCart.buyer_operation_id ? '' : 'col-lg-6'">
                <img src="img/misc/store-graphs.png" class="img-fluid" style="height: 250px" />
                <div style="background: rgb(234, 235, 240)" class="d-flex flex-wrap justify-content-around align-items-center mx-2 rounded p-3">
                  <div v-if="buyerData.net_terms_id || storefrontCompany.terms_and_conditions || storefrontCompany.backorder_tos" class=" ">
                    <h4 v-if="buyerData.net_terms_id" class="d-inline text-primary">
                      {{ "Terms" }}:
                      {{ buyerData.term.name }}
                    </h4>
                    <div v-if="storefrontCompany.terms_and_conditions || storefrontCompany.backorder_tos">
                      <BushelBtn flat class="btn-sm" @click="showingTerms = !showingTerms"> View Terms & Conditions </BushelBtn>
                      <TermsAndConditionsModal
                        v-if="showingTerms"
                        :show="showingTerms"
                        :terms="storefrontCompany.terms_and_conditions"
                        :pre-order-terms="storefrontCompany.backorder_tos"
                        @hide="showingTerms = false"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="ml-auto mr-auto">
                      <h4 class="text-primary">
                        <b>Final Total: {{ currency(finalTotal) }}</b>
                      </h4>
                      <div>
                        <BushelBtn
                          v-if="!user || !user.id || userCan('make orders', user)"
                          class="ml-auto mr-auto mt-1 min-180px align-top"
                          :loading="dispatchingOrder"
                          variant="success"
                          :disabled="!storefrontCompany.approved || (buyerData && buyerData.hold)"
                          @click="createOrder"
                        >
                          <span v-if="!dispatchingOrder"> Place Order </span>
                        </BushelBtn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BushelCard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint camelcase: "off" */

import { mapState, mapGetters } from "vuex";
import { isObjEmpty, userCan, navTo, validateEmail } from "@/services/helpers";
import CartOrderBreakout from "@/components/storefront/CartOrderBreakout.vue";
import BuyerContactModal from "@/components/buyer/BuyerContactModal.vue";
import TermsAndConditionsModal from "@/components/storefront/TermsAndConditionsModal.vue";
import { currency } from "@/services/filters";

export default {
  components: {
    CartOrderBreakout,
    BuyerContactModal,
    TermsAndConditionsModal,
  },
  props: {
    storefrontCompany: { type: Object, required: true },
    cartItems: { type: Array, required: true },
    cartMinimums: { type: Object, required: true },
    loadingCart: { type: Boolean, required: true },
    buyerData: { type: Object, required: true },
    dispatchingOrder: { type: Boolean, required: true },
    createdOrder: { type: Boolean, required: true },
    loggedIn: { type: Boolean, required: true },
    isTheSeller: { type: Boolean, required: true },
    orderGroups: { type: Array, required: true },
    cartOptions: { type: Array, required: true },
    activeCart: { type: Object, required: true },
  },
  emits: [
    "viewOrders",
    "createOrder",
    "startSneakyLogin",
    "startSneakyRegister",
    "backToStorefront",
    "removeFromCart",
    "adjustToMaxQuantityInCart",
    "handleUpdateQuantity",
    "backToStorefrontAndFetchItems",
    "fetchCart",
  ],
  data() {
    return {
      showingTerms: false,
      submitted: false,
      showingBuyerContactModal: false,
      industry: APP_INDUSTRY,
      appName: APP_NAME,
      linkCopied: false,
      selectedBuyerLocation: null,
      selectedBuyerOperation: null,
      selectedOrderEmail: null,
      selectedLocation: null,
      // paymentMethods: [],
      internalGroups: [],
      addressType: "Location",
      orderDetails: {
        note: "",
        shipping_method: "",
        ship_name: "",
        ship_line_one: "",
        ship_line_two: "",
        ship_city: "",
        ship_state: "",
        ship_zip: "",
        ship_country: "",
        ship_operation_id: "",
        buyer_state_license: null,
        buyer_location_id: null,
        buyer_operation_id: null,
        seller_company_id: null,
        buyer_manually_entered_email: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      currentCompany: "companies/currentCompany",
    }),
    userCanUseFinancing() {
      if (this.userCan("use financing", this.user)) {
        return true;
      }
      return false;
    },
    cartsWithItems() {
      return this.cartOptions.filter((cart) => cart.cart_items.length);
    },
    selectableOperations() {
      if (this.buyerData.buyer_company && this.buyerData.buyer_company.id) {
        if (this.usCannabisUser) {
          return this.buyerData.buyer_company.operations.filter(
            (op) =>
              !op.disabled &&
              op.state_id == this.storefrontCompany.state_id &&
              op.country_id == this.storefrontCompany.country_id &&
              op.state_license != null &&
              op.state_license.length,
          );
        }
        return this.buyerData.buyer_company.operations;
      }
      return [];
    },
    selectableLocations() {
      if (this.buyerData.locations) {
        if (this.usCannabisUser) {
          return this.buyerData.locations.filter(
            (l) =>
              l.state_id == this.storefrontCompany.state_id &&
              l.country_id == this.storefrontCompany.country_id &&
              l.state_license != null &&
              l.state_license.length,
          );
        }
        return this.buyerData.locations.filter((l) => l.country && l.country.text && l.state && l.state.text);
      }
      return [];
    },
    selectableContacts() {
      if (this.buyerData.contacts) {
        return this.buyerData.contacts.filter((c) => c.email);
      }
      return [];
    },
    showOperationSelect() {
      if (this.selectableOperations && this.selectableOperations.length >= 1) {
        return true;
      }

      return false;
    },
    showLocationSelect() {
      if (this.selectableLocations && this.selectableLocations.length >= 1 && !this.showOperationSelect) {
        return true;
      }

      return false;
    },
    buyerPrivateStorefrontlink() {
      return `https://${window.location.hostname}/menu/${this.storefrontCompany.slug}/${this.buyerData.slug}/${this.buyerData.uuid}?proposal=true`;
    },
    usCannabisUser() {
      if (this.industry != "cannabis") {
        return false;
      }

      if (this.storefrontCompany.country && this.storefrontCompany.country.value == "US" && this.storefrontCompany.merchandise_company) {
        return false;
      }

      if (this.storefrontCompany.country && this.storefrontCompany.country.value != "US") {
        return false;
      }
      return true;
    },
    finalTotal() {
      let total = this.cartItems.reduce((accumulator, item) => accumulator + item.finalPrice, 0);
      if (this.buyerData && this.buyerData.credit_total > 0) {
        const amtToApply = this.buyerData.credit_total > total ? total : this.buyerData.credit_total;
        total -= amtToApply;
      }
      return total;
    },
    inventoryStockIssue() {
      return this.cartItems.some(
        (item) =>
          item.unavailable ||
          (item.tracksInventory && (!item.sample || item.tracksSampleQuantity) && item.availableQuantity < this.quantityInCart(item, true)),
      );
    },
    ...mapState("auth", {
      user: (state) => state.user,
    }),
  },
  watch: {
    cartItems(val) {
      this.createInternalOrderGroups();
    },
    addressType(oldVal, newVal) {
      this.clearBuyerOperationLocationData();
    },
  },
  created() {},

  mounted() {
    this.fetchFullCart(this.activeCart);
    // this.setPaymentMethods();
    if (this.selectableContacts && this.selectableContacts.length && (!this.buyerData.buyer_company || !this.buyerData.buyer_company.id)) {
      this.orderDetails.buyer_manually_entered_email = this.selectableContacts[0].email;
    }
    if (this.usCannabisUser) {
      this.orderDetails.ship_state = this.storefrontCompany.state.text;
      this.orderDetails.ship_country = this.storefrontCompany.country.value;
    }
  },
  methods: {
    isObjEmpty,
    userCan,
    navTo,
    validateEmail,
    currency,
    copyStorefrontLink() {
      this.copyTextToClipboard(this.buyerPrivateStorefrontlink);
    },
    quantityInCart(checkedItem, returnValue = false) {
      let returnData = 0;
      if (this.cartItems && this.cartItems.length) {
        const foundItems = this.cartItems.filter((item) => {
          if (item.batch_id == checkedItem.batch_id && item.product_id == checkedItem.product_id && !item.sample) {
            return true;
          }
          return false;
        });

        for (let i = 0; i < foundItems.length; i += 1) {
          returnData += foundItems[i].quantity;
        }
        if (returnValue) {
          return Number(returnData);
        }

        return `${returnData.toString()}`;
      }
      return 0;
    },
    copyTextToClipboard(text) {
      const that = this;
      if (!navigator.clipboard) {
        // fallback for unsuported browsers
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          const successful = document.execCommand("copy");
          if (successful) {
            that.linkCopied = true;
          }
        } catch (err) {
          // error
        }
        document.body.removeChild(textArea);
        return;
      }
      navigator.clipboard.writeText(text).then(
        () => {
          that.linkCopied = true;
        },
        (err) => {
          // err
        },
      );
    },
    customBuyerLabel({ name, state_license }) {
      if (!this.usCannabisUser) {
        return `${name}`;
      }
      return `${name} ${state_license ? `| ${state_license}` : ""}`;
    },
    customContactLabel({ name, email }) {
      return `${name} ${email ? `| ${email}` : ""}`;
    },
    changeAddressType(type) {
      this.addressType = type;
    },
    createOrder(data = {}) {
      if (!this.inventoryStockIssue && this.storefrontCompany.approved) {
        let error = false;
        this.submitted = false;

        if (
          !this.orderDetails.ship_name ||
          !this.orderDetails.ship_line_one ||
          !this.orderDetails.ship_city ||
          !this.orderDetails.ship_state ||
          !this.orderDetails.ship_zip ||
          !this.orderDetails.ship_country
        ) {
          error = true;
        }

        if (!this.isTheSeller) {
          if (
            (!this.buyerData || !this.buyerData.buyer_company || !this.buyerData.buyer_company.id) &&
            !this.validateEmail(this.orderDetails.buyer_manually_entered_email)
          ) {
            error = true;
          }
        }

        if (this.usCannabisUser && !this.orderDetails.buyer_state_license) {
          error = true;
        }

        for (const group in this.internalGroups) {
          if (Object.prototype.hasOwnProperty.call(this.internalGroups, group)) {
            const order = this.internalGroups[group].orderDetails;
            this.internalGroups[group].orderDetails = {
              ...this.orderDetails,
              note: order.note,
              shipping_method: order.shipping_method,
            };
          }
        }

        if (!error) {
          this.$emit("createOrder", {
            origination: "Storefront",
            orderGroups: this.internalGroups,
          });
        } else {
          this.submitted = true;
        }
      }
    },
    fetchFullCart(cart) {
      this.$emit("fetchCart", cart);
      this.handleLocalCartChange(cart);
    },
    handleLocalCartChange(cart) {
      if (cart.buyer_location_id) {
        const foundLocation = this.selectableLocations.find((loc) => loc.id == cart.buyer_location_id);
        this.locationSelected(foundLocation);
      } else if (cart.buyer_operation_id) {
        const foundOp = this.selectableOperations.find((op) => op.id == cart.buyer_operation_id);
        this.operationSelected(foundOp);
      } else {
        this.selectedBuyerOperation = null;
        this.selectedBuyerLocation = null;
        this.orderDetails.buyer_location_id = null;
        this.orderDetails.buyer_operation_id = null;
        this.orderDetails.ship_name = this.buyerData.name;
        this.orderDetails.ship_line_one = "";
        this.orderDetails.ship_line_two = "";
        this.orderDetails.ship_city = "";
        this.orderDetails.buyer_state_license = null;
        this.orderDetails.ship_zip = "";
        if (!this.usCannabisUser) {
          this.orderDetails.ship_state = "";
          this.orderDetails.ship_country = "";
        }
      }
    },
    locationSelected(location) {
      this.selectedBuyerLocation = location;
      this.selectedBuyerOperation = null;
      this.orderDetails.buyer_location_id = location.id;
      this.orderDetails.buyer_operation_id = null;
      this.orderDetails.ship_name = location.name;
      this.orderDetails.ship_line_one = location.line_one;
      this.orderDetails.ship_line_two = location.line_two;
      this.orderDetails.ship_city = location.city;
      this.orderDetails.ship_state = location.state ? location.state.text : null;
      this.orderDetails.ship_zip = location.zip;
      this.orderDetails.ship_country = location.country ? location.country.value : null;
      if (this.usCannabisUser) {
        this.orderDetails.buyer_state_license = location.state_license;
      }
    },
    createInternalOrderGroups() {
      // const newGroups = [];
      const newGroups = {};
      for (let i = 0; i < this.orderGroups.length; i += 1) {
        const newGroup = this.orderGroups[i];
        newGroup.identifier = i;
        newGroup.orderDetails = { ...this.orderDetails };
        newGroups[i] = newGroup;
      }

      this.internalGroups = newGroups;
    },
    buyerContactSelected(contact) {
      this.orderDetails.buyer_manually_entered_email = contact.email;
    },
    clearBuyerOperationLocationData() {
      this.selectedBuyerLocation = null;
      this.selectedBuyerOperation = null;
      this.orderDetails.buyer_location_id = null;
      this.orderDetails.buyer_operation_id = null;
      this.orderDetails.buyer_state_license = null;
    },
    operationSelected(operation) {
      this.selectedBuyerLocation = null;
      this.selectedBuyerOperation = operation;
      this.orderDetails.ship_operation_id = operation.id;
      this.orderDetails.buyer_location_id = null;
      this.orderDetails.buyer_operation_id = operation.id;
      this.orderDetails.ship_name = operation.name;
      this.orderDetails.ship_line_one = operation.line_one;
      this.orderDetails.ship_line_two = operation.line_two;
      this.orderDetails.ship_city = operation.city;
      this.orderDetails.ship_state = operation.state ? operation.state.text : null;
      this.orderDetails.ship_zip = operation.zip;
      this.orderDetails.ship_country = operation.country ? operation.country.value : null;

      if (this.usCannabisUser) {
        this.orderDetails.buyer_state_license = operation.state_license;
      }
    },
    updateFieldInGroup(data) {
      const foundGroup = { ...this.internalGroups[data.identifier] };
      if (foundGroup.orderDetails[data.field] != data.value) {
        foundGroup.orderDetails[data.field] = data.value;
        this.internalGroups = { ...this.internalGroups, [data.identifier]: foundGroup };
      }
    },
  },
};
</script>

<style scoped></style>
